module.exports = __webpack_public_path__ + "img/discover-dapps-purple.dcc60886.svg";